/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IRelation } from 'app/shared/model/relation.model';
import { IPackageSubscription } from 'app/shared/model/package-subscription.model';

export interface IPackageSubscriber {
  id?: string;
  primaryUser?: boolean | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  subscriberNumber?: string | null;
  scubscriber?: IGlucoUser | null;
  relationToPrimary?: IRelation | null;
  subscription?: IPackageSubscription | null;
}

export const defaultValue: Readonly<IPackageSubscriber> = {
  primaryUser: false,
  active: false,
};
